<div class="preloader position-absolute d-flex align-items-center justify-content-center text-center" role="progressbar"
  aria-busy="true">
  <div class="lines position-absolute">
    <div class="wrapper col-12 p-0">
      <div class="line line-1 w-100 position-absolute"></div>
    </div>

    <div class="col-12 p-0">
      <p class="loading-text font-bold mt-2 mb-0">{{loaderText ? loaderText : 'Loading...'}}</p>
    </div>
  </div>
</div>
